<kendo-grid [sort]="DataService.state.sort" [sortable]="true" [dir]="biService.getDir() ? 'rtl': 'ltr'"
  [height]="height ? height : 300" #Grid [filterable]="'menu'" [data]="GridData | async"
  [resizable]="true" [selectable]="true" kendoGridSelectBy [(selectedKeys)]="mySelection"
  (cellClick)="cellClickHandler($event)" (dataStateChange)="onValueChange($event)"
  (cellClose)="cellCloseHandler($event)">
  <!-- Your column definitions here -->
  <ng-container *ngFor="let res of Columns" [ngSwitch]="res.controlType">
    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="'text'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
      [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
        <kendo-textbox [formControl]="formGroup.controls[res.Name]" [value]="formGroup.getRawValue()[res.Name]"
          (change)="bindingData($event, res.Name)"></kendo-textbox>
        <span *ngIf="formGroup.controls[res.Name].invalid">
          <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
            {{res.DisplayName}} {{'IsRequired' | translate}}
          </span>
          <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.email">
            {{'Emailaddressisinvalid' | translate}}
          </span>
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem | getValue : res.Name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
                       *ngSwitchCase="'numeric'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
                       [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
        <input [formControl]="formGroup.controls[res.Name]" type="number" class="form-control"
               (change)="bindingData($event, res.Name)" [value]="formGroup.getRawValue()[res.Name]">
        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
          {{res.DisplayName}} {{'IsRequired' | translate}}
        </span>
        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.max">
          {{res.DisplayName | translate}} {{'maxValueIs'|translate}}
          {{formGroup.controls[res.Name].errors?.max?.max}}
        </span>

        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.min">
          {{res.DisplayName | translate}} {{'minValueIs'|translate}}
          {{formGroup.controls[res.Name].errors?.min?.min}}
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [ngStyle]="res.ConditionalCellStyleFn ? res.ConditionalCellStyleFn(dataItem) : ''">
          {{ dataItem | getValue : res.Name}}
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{
        dataItem | getValue : res.Name| number: res.Precision? '1.' + res.Precision + '-' + res.Precision :
        DefaultPrecision |negativeValueTransform
        }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="'date'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
      [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
        <kendo-datepicker [formControl]="formGroup.controls[res.Name]" [value]="formGroup.getRawValue()[res.Name]"
          (valueChange)="bindingData($event, res.Name)" calendarType="classic"></kendo-datepicker>
        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
          {{res.DisplayName}} {{'IsRequired' | translate}}
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem | getValue : res.Name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" *ngSwitchCase="'boolean'"
      [filter]="res.DataType" [hidden]="!res.IsVisible" [field]="res.Name" [title]="res.DisplayName | translate"
      [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridHeaderTemplate *ngIf="HasSelectAll || res?.checkboxTemplate?.HasSelectAll">
        <input type="checkbox" [(ngModel)]="selectAll" (change)="changeCheckAll($event, res.Name)">
        <span *ngIf=" res?.checkboxTemplate?.HasSelectAllLabel">
          {{'SelectAll' | translate}}
        </span>
      </ng-template>
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-rowIndex="rowIndex"
        *ngIf="res?.checkboxTemplate?.HasSelectAll">
        <input type="checkbox" (change)="changeCheckBox($event, res.Name, dataItem, rowIndex)"
          [checked]="dataItem[res.Name] || selectAll"
          [disabled]="!res.IsEditable||(IsDisabledCellTemplate(dataItem[this.RowIdentifier],res.Name)) " />
        <!-- <input type="checkbox" [checked]="dataItem[res.Name] || selectAll" [formControl]="formGroup.controls[res.Name]"
          [value]="formGroup.getRawValue()[res.Name]"/> -->
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem *ngIf="res?.checkboxTemplate?.HasSelectAll"
        let-rowIndex="rowIndex">
        <input type="checkbox" (change)="changeCheckBox($event, res.Name, dataItem, rowIndex)"
          [checked]="dataItem[res.Name] || selectAll"
          [disabled]="!res.IsEditable||(IsDisabledCellTemplate(dataItem[this.RowIdentifier],res.Name)) " />
      </ng-template>

      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-rowIndex="rowIndex"
        *ngIf="!res?.checkboxTemplate?.HasSelectAll">
        <input type="checkbox" [checked]="dataItem[res.Name]" [formControl]="formGroup.controls[res.Name]"
          [value]="formGroup.getRawValue()[res.Name]" />
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem *ngIf="!res?.checkboxTemplate?.HasSelectAll"
        let-rowIndex="rowIndex">
        <input type="checkbox" (change)="changeCheckBox($event, res.Name, dataItem, rowIndex)"
          [checked]="dataItem[res.Name]" [disabled]="!res.IsEditable" />
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="'select'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
      [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-dropdownlist [data]="res?.dropDownTemplate?.list" [textField]="'' + res?.dropDownTemplate?.text"
          [valueField]="''+res?.dropDownTemplate?.value"
          (valueChange)="filterByDropList($event, filterService, res.Name)" [valuePrimitive]="true">
        </kendo-dropdownlist>
      </ng-template>
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
        <bi-dropDown [Name]="res.Name" [DropDownList]="res?.dropDownTemplate?.list"
          [BindingProperty]="formGroup.controls[res.Name]" [ValueField]="res?.dropDownTemplate?.value"
          [TextField]="res?.dropDownTemplate?.text"></bi-dropDown>

        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
          {{res.DisplayName}} {{'IsRequired' | translate}}
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [colorStatus]="{key: dataItem[res.Name], colors: colorsLines}">
          {{ GetDropDownTxtValueByCode(dataItem | getValue : res.Name, res?.dropDownTemplate) }}
        </span>
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="'lookup'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
      [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridEditTemplate let-formGroup="formGroup">
        <app-bi-lookup [BindingProperty]="formGroup.controls[res.Name]"
          [DataSource]="res.lookupTemplate?.['DataSource']" [Key]="res.lookupTemplate?.['Key']"
          [Title]="res.DisplayName" [DomID]="res.lookupTemplate?.['ID']" [DataType]="res.DataType"
          [hasSecondLkp]="res.lookupTemplate?.['hasSecondLkp'] ? true : false"
          (AfterLoad)="res.lookupTemplate?.AfterLoad && res.lookupTemplate?.AfterLoad()"
          (BeforeLoad)="res.lookupTemplate?.BeforeLoad && res.lookupTemplate?.BeforeLoad()"
          (OnClose)="res.lookupTemplate?.OnClose && res.lookupTemplate?.OnClose()"
          (OnOpen)="res.lookupTemplate?.OnOpen && res.lookupTemplate?.OnOpen()"
          (OnOpenSecondLkp)="res.lookupTemplate?.OnOpenSecondLkp && res.lookupTemplate?.OnOpenSecondLkp()"
          (ReturnedValueEmitter)="res.lookupTemplate?.ReturnedValueEmitter&&res.lookupTemplate?.ReturnedValueEmitter($event)"
          [setPreventCloseRow]="setPreventCloseRow" [classNameSelector]="'padding-button-reset btn btn-light'">
        </app-bi-lookup>
        <!-- (ErrorStateEmitter)="GetLookupErrorState($event, res.Name)"> -->

        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
          {{res.DisplayName | translate}} {{'IsRequired' | translate}}
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem | getValue : res.Name }}
      </ng-template>
    </kendo-grid-column>
  </ng-container>
</kendo-grid>
